module.exports = __webpack_public_path__ + "static/img/verify-envelope.538fc8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify-envelope.svg
// module id = 3250
// module chunks = 1